<script lang="ts">
	import type { CompleteVariant, RequiredProduct } from '$lib/types';
	import { parseHighlight, percentOf } from '$lib/utils/product';
	import ProductPrice from '$lib/components/Product/ProductPrice.svelte';
	import SaleChip from '$lib/components/Product/SaleChip.svelte';
	import UnitPrice from '$lib/components/Product/UnitPrice.svelte';

	export let product: RequiredProduct;
	export let variant: CompleteVariant;
	export let showJdm: boolean;

	$: highlights = parseHighlight(product.highlights);
	$: sale = percentOf(variant.price, variant.compareAtPrice);
</script>

<h1 class="text-h-32">{product.title}</h1>
<div class="text-p-16 pt-1.5">
	{#if highlights}
		<p title={highlights}>{highlights}</p>
	{/if}
	{#if showJdm}
		<div
			class="jdgm-widget jdgm-preview-badge"
			data-id={product.id.replace('gid://shopify/Product/', '')}
		/>
	{/if}
</div>

<div class="font-semibold flex gap-4 items-end text-h-24 pt-1.5">
	<ProductPrice price={variant.price} compareAtPrice={variant.compareAtPrice} />
	<SaleChip {sale} />
</div>
<UnitPrice
	price={variant.price}
	measurementPrice={variant.unitPrice || undefined}
	referenceUnit={variant.bundle_desc?.value}
	measurement={variant.unitPriceMeasurement}
	showNote
/>
